export const round = (value: number): number => {
  return parseFloat(value.toFixed(2));
};



// WEBPACK FOOTER //
// ./src/app/shared/utils/number.utils.ts